import React from "react";

const menuData = [
  {
    category: "Cakes",
    items: [
      { name: "Chocolate Truffle", image: require("../images/banner.jpg") },
      { name: "Vanilla Cream", image: require("../images/banner.jpg") },
    ],
  },
  {
    category: "Pastries",
    items: [
      { name: "Strawberry Pastry", image: require("../images/banner.jpg") },
      { name: "Black Forest", image: require("../images/banner.jpg") },
    ],
  },
  {
    category: "Breads",
    items: [
      { name: "Garlic Bread", image: require("../images/banner.jpg") },
      { name: "Croissant", image: require("../images/banner.jpg") },
    ],
  },
];

const Menu = () => {
  return (
    <section id="menu" className="menu-section">
      <h2 className="menu-title">Our Menu</h2>
      {menuData.map((section, index) => (
        <div key={index} className="menu-category">
          <h3>{section.category}</h3>
          <div className="menu-items">
            {section.items.map((item, idx) => (
              <div key={idx} className="menu-card">
                <img src={item.image} alt={item.name} className="menu-img" />
                <p className="menu-name">{item.name}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
};

export default Menu;
